export default __webpack_public_path__ + "static/media/man-bg.81e47cf6.png";